import { ICacheProject, ICacheStorageState } from "../types";
import CacheModel from "./CacheModel";
import { cacheModules } from "../caches";
import { bimFileApi } from "apiClient/v2";
import {
  deleteModelCache,
  getUrlsCachedOfProject,
  getUrlsOfModel,
} from "utils/cache";
import { DataProjectModel } from "interfaces/models/dataProjectModel";

class CacheProject extends CacheModel implements ICacheProject {
  constructor(public readonly id: string, defaultState?: ICacheStorageState) {
    super(id, defaultState);
  }

  public getProgress(): number {
    const allKeys = cacheModules.map((cache) => cache.key);
    const totalKeys = allKeys.length;
    const keys = this.getKeysCached();

    return totalKeys ? Math.floor((keys.length / totalKeys) * 100) : 0;
  }

  public isCacheDone(): boolean {
    return this.getProgress() === 100;
  }

  public async clear(dataProjectModel: DataProjectModel) {
    await this.clearUrlsOfModel(dataProjectModel);
    await this.reset();
  }

  public async loadNewestDataFromServer() {
    const cachedUrls = await this.getCachedUrls();
    const keys = new Set(this.getKeys());
    keys.forEach((key) => {
      if (!cachedUrls.includes(key)) {
        keys.delete(key);
      }
    });
    this.setKeys(Array.from(keys));
  }

  public async getCachedUrls() {
    const data = await this.getLastUpdatedResource();

    const resources = this.getResources();

    return getUrlsCachedOfProject(data, resources);
  }

  public async updateResourceCached() {
    const data = await this.getLastUpdatedResource();
    this.setResources(data);
  }

  protected async getLastUpdatedResource() {
    const res = await bimFileApi.getLastUpdatedResource({
      bimFileId: this.id,
    });

    return res.data ?? [];
  }

  protected async clearUrlsOfModel(dataProjectModel: DataProjectModel) {
    const urls = await getUrlsOfModel(dataProjectModel);
    if (urls) {
      await deleteModelCache(urls);
    }
  }
}

export default CacheProject;
